import React from "react";
import styles from "~/areas/infrastructure/components/InfrastructureDashboard/HealthStatusCard/HealthStatusContentIconContainer.less";

export function HealthStatusContentIconContainer({ children }: React.PropsWithChildren<{}>) {
    return <div className={styles.healthStatusIconContainer}>{children}</div>;
}
